var generateComponentTheme = function generateComponentTheme(_ref) {
  var borders = _ref.borders,
    colors = _ref.colors,
    spacing = _ref.spacing,
    typography = _ref.typography;
  return {
    contentBorderRadius: borders.radiusMedium,
    contentBackgroundColor: colors.white,
    contentBorder: borders.widthMedium,
    contentBorderColor: colors.porcelain,
    userResponsePadding: spacing.xSmall,
    iconHolderFontSize: typography.fontSizeSmall,
    iconHolderColor: colors.white,
    iconHolderBackgroundColor: colors.tiara,
    correctBorderColor: colors.shamrock,
    correctFontSize: typography.fontSizeMedium,
    correctBackgroundColor: colors.shamrock,
    incorrectBorderColor: colors.crimson,
    incorrectFontSize: typography.fontSizeMedium,
    incorrectBackgroundColor: colors.crimson,
    gradedBorderColor: colors.electric,
    gradedFontSize: typography.fontSizeMedium,
    gradedBackgroundColor: colors.electric
  };
};
export default generateComponentTheme;